import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { applyZipCodeMask } from '@clickersphere/core/utils/zipCodeMask';
import { IContractAddressFormValues } from '../../app/utils/contractAddressForm';
import { Input } from './Input';

interface IContractAddressFieldsFormValues {
  address: IContractAddressFormValues;
}

interface IContractAddressFieldsProps {
  disabled?: boolean;
}

export default function ContractAddressFields({
  disabled,
}: IContractAddressFieldsProps) {
  const { t } = useTranslation();
  const { register, control } =
    useFormContext<IContractAddressFieldsFormValues>();

  return (
    <fieldset className="flex w-full flex-col gap-4">
      <legend className="text-text-secondary mb-2 text-sm font-medium">
        {t('contract.address.title')}
      </legend>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <Input
            type="text"
            placeholder={t('contract.address.fields.street')}
            {...register('address.street')}
            disabled={disabled}
          />
        </div>
        <Input
          type="text"
          placeholder={t('contract.address.fields.number')}
          {...register('address.number')}
          disabled={disabled}
        />
        <Input
          type="text"
          placeholder={t('contract.address.fields.complement')}
          {...register('address.complement')}
          disabled={disabled}
        />
        <Input
          type="text"
          placeholder={t('contract.address.fields.neighborhood')}
          {...register('address.neighborhood')}
          disabled={disabled}
        />
        <Controller
          control={control}
          name="address.zipCode"
          render={({ field: { name, value, onChange } }) => (
            <Input
              type="text"
              inputMode="numeric"
              maxLength={9}
              name={name}
              value={value}
              onChange={(e) => onChange(applyZipCodeMask(e.target.value))}
              placeholder={t('contract.address.fields.zipCode')}
              disabled={disabled}
            />
          )}
        />
        <Input
          type="text"
          placeholder={t('contract.address.fields.city')}
          {...register('address.city')}
          disabled={disabled}
        />
        <Input
          type="text"
          placeholder={t('contract.address.fields.state')}
          {...register('address.state')}
          disabled={disabled}
        />
      </div>
    </fieldset>
  );
}
